import { GuestCheckoutParams } from "src/app/core/services/myqq";

export function registerUrl(url: string) {
  return (redirectUri: string, code_challenge: string) =>
    `${url}/auth/realms/myqq/protocol/openid-connect/registrations?client_id=myqq&response_type=code&scope=${encodeURIComponent(
      "openid email offline_access"
    )}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&kc_locale=en&code_challenge=${code_challenge}&code_challenge_method=S256`;
}

export function registerGuestUrl(url: string) {
  return (
    redirectUri: string,
    code_challenge: string,
    params: GuestCheckoutParams
  ) =>
    `${url}/auth/realms/myqq/protocol/openid-connect/registrations?client_id=myqq&response_type=code&scope=${encodeURIComponent(
      "openid email offline_access"
    )}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&kc_locale=en&code_challenge=${code_challenge}&code_challenge_method=S256&flow=${
      params.flow
    }&fullName=${params.fullName}&phoneNumber=${params.phoneNumber}&email=${
      params.email
    }&total=${params.total}&flock=${params.flock}&subscriptionType=${
      params.subscriptionType
    }`;
}
